import React from 'react';
import { Wrench, Settings, Cog, Battery, Gauge, Car } from 'lucide-react';
import './style.css';
const SplashScreen: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-white-900 via-blue-900 to-blue-900 flex flex-col items-center justify-center p-4 overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        {/* Floating Tools */}
        {[...Array(12)].map((_, i) => {
          const Icon = [Settings, Cog, Wrench, Battery, Car, Gauge][i % 6];
          return (
            <Icon
              key={i}
              className="absolute text-white/5"
              style={{
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
                fontSize: `${Math.random() * 40 + 20}px`,
                animation: `float-tool ${Math.random() * 15 + 10}s linear infinite`,
                animationDelay: `-${Math.random() * 15}s`,
                transform: `rotate(${Math.random() * 360}deg)`
              }}
            />
          );
        })}
        
        {/* Light Beams */}
        {[...Array(5)].map((_, i) => (
          <div
            key={`beam-${i}`}
            className="absolute w-1 h-[300px] bg-gradient-to-b from-blue-400/0 via-blue-400/10 to-blue-400/0"
            style={{
              left: `${20 + i * 20}%`,
              transform: 'rotate(45deg)',
              animation: `light-beam ${3 + i}s ease-in-out infinite`,
              animationDelay: `${i * 0.5}s`
            }}
          />
        ))}
      </div>

      {/* Main Title with Effects */}
      <div className="relative mb-16 text-center items-center flex justify-center">
            <img src="/images/logo.png" className='w-[50%]' />
      </div>

      {/* Animation Stage */}
      <div className="relative w-full max-w-3xl h-80 rounded-xl bg-gradient-to-b from-blue-400/50 to-blue-900/50 backdrop-blur-sm overflow-hidden shadow-2xl">
        {/* Stars Effect */}
        <div className="absolute inset-0">
          {[...Array(30)].map((_, i) => (
            <div
              key={`star-${i}`}
              className="absolute w-1 h-1 bg-white rounded-full animate-twinkle"
              style={{
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 3}s`
              }}
            />
          ))}
        </div>

        {/* Animated Road */}
        <div className="absolute bottom-0 w-full h-24">
          <div className="absolute bottom-0 w-full h-full bg-gradient-to-t from-slate-900 to-slate-800">
            <div className="relative h-full overflow-hidden">
              {/* Road Stripes */}
              <div className="absolute bottom-8 w-full h-4">
                <div className="animate-road-scroll h-full">
                  {[...Array(10)].map((_, i) => (
                    <div
                      key={`stripe-${i}`}
                      className="absolute h-2 w-16 bg-yellow-400/80 rounded-full blur-[2px]"
                      style={{ left: `${i * 200}px` }}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Cityscape */}
        <div className="absolute bottom-24 w-full">
          <div className="relative h-32">
            <div className="animate-buildings absolute w-[200%] h-full">
              {[...Array(12)].map((_, i) => (
                <div
                  key={`building-${i}`}
                  className="absolute bottom-0 bg-gradient-to-t from-slate-800 to-slate-700/50 rounded-t-lg"
                  style={{
                    left: `${i * 10}%`,
                    height: `${Math.random() * 60 + 40}px`,
                    width: '30px',
                  }}
                >
                  {/* Building Windows */}
                  {[...Array(3)].map((_, j) => (
                    <div
                      key={`window-${i}-${j}`}
                      className="absolute w-2 h-2 bg-yellow-400/30 rounded"
                      style={{
                        left: '50%',
                        transform: 'translateX(-50%)',
                        top: `${j * 30}%`,
                        animation: `window-flicker ${Math.random() * 4 + 2}s ease-in-out infinite`
                      }}
                    />
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Moving Car with Enhanced Effects */}
        <div className="absolute bottom-20 animate-car-movement">
          <div className="relative group">
            <img 
              src="/images/car.png" 
              alt="Service Van" 
              className="w-32 h-auto transform transition-transform group-hover:scale-105"
              style={{
                filter: 'drop-shadow(0 4px 6px rgba(0, 0, 0, 0.5))',
              }}
            />
            
            {/* Enhanced Speed Lines */}
            <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2">
              <div className="relative w-24">
                <div className="absolute inset-0 flex justify-around">
                  {[...Array(5)].map((_, i) => (
                    <div
                      key={`speed-${i}`}
                      className="w-1 h-6 bg-blue-400/20 rounded-full blur-sm"
                      style={{
                        animation: 'speed-lines 0.5s infinite',
                        animationDelay: `${i * 0.1}s`
                      }}
                    />
                  ))}
                </div>
              </div>
            </div>

            {/* Enhanced Service Sparkles */}
            <div className="absolute -top-6 left-1/2 transform -translate-x-1/2">
              <div className="relative">
                {[...Array(4)].map((_, i) => (
                  <div
                    key={`sparkle-${i}`}
                    className="absolute w-2 h-2 bg-gradient-to-br from-yellow-400 to-yellow-200 rounded-full"
                    style={{
                      animation: 'sparkle 1.5s infinite',
                      animationDelay: `${i * 0.4}s`,
                      left: `${(i - 1.5) * 12}px`
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

  
    </div>
  );
};
export default SplashScreen;
